/*eslint-disable */
import React, { Component } from "react";
import OrdersHeader from "../../components/orderComponent/ordersHeaders";
import { readOrderDispatcher } from "../../redux/actions/allOrdersAction";
import { connect } from "react-redux";
import ReadAxios from "../../components/axiosComponent/read";
import CreatAxios from "../../components/axiosComponent/create";
import DeliveryAgGridTable from "../../components/common/deliveryaggrid";
import FormikModalMapDelivery from "./mapdeliveryModal";
import FormikModalDemapDelivery from "./demapdeliveryModal";

import AgGridTable from "../../components/common/agGridTable";
import {
  successAlertDispatcher,
  errorAlertDispatcher,
} from "../../redux/actions/alertAction";
// import ModalBroadCast from "./modalBroadCast";
// import FormikModalAllot from "./modalAllot";
import { translate } from "react-i18next";
import { isEmpty } from "lodash";
import { Grid, Button } from "semantic-ui-react";
import moment from "moment";
import Vehicletyperenderer from "../common/vehicletyperenderer";
import Sourcerender from "../common/sourcerender";
import Destinationrender from "../common/destinationrender";
import BLrender from "../common/bl_no";
import Allotmentrender from "../common/allotmentrender";
import LoadingPlaceholder from "../placeholderComponent/loadingPlaceholder";
import DeliveriesActionCollection from "./deliveriesActionCollection";
import ModalEditAddDeliveries from "../createShipmentComponent/modalEditAddDeliveries";
import UpdateAxios from "../axiosComponent/update";
import cogoToast from "cogo-toast";
import { consigneeConsignorCheck, consigneeId, consignorId, deliveryCode_ALLOC, deliveryCode_CANCEL, deliveryCode_LOADING_GATEOUT, branch_Ids } from '../../utils/constant'

class DeliveryList extends Component {
  constructor(props) {
    super(props);
    const { t } = props;
    this.state = {
      clickedDeliveryID: "",
      loadingData: false,
      generated_order: false,
      isLoading: false,
      club: false,
      prevProps: [],
      OrderLists: "",
      rowData: [],
      locales: props.locales.local,
      paginationCallbackData: [],
      chunkedRowData: [],
      currentPageData: [],
      selectedRows: [],
      currentPageNumber: -1,
      componentRenderKey: 0,
      currentPage: 1,
      itemCount: 10,
      itemsPerPage: 10,
      totalItems: null,
      totalPages: null,
      openModalDelivery: false,
      deliveryDataFetch: {},
      passMode: "view",
    };
  }

  componentDidMount() {
    // this.props.read();
    //ReadAxios({ completeURL: `${process.env.REACT_APP_TA_API_URL}/deliveries?page=1&limit=` })
    this.handleOrderAPICall();
  }

  handleOrderAPICall = () => {
    this.setState({loadingData: true})
    let booking_branch_ids = branch_Ids?.length > 0 ? branch_Ids.toString()
      : ''
    let Id, idValue
    if (consignorId) {
      Id = 'consignor_id'
      idValue = consignorId
    } else if (consigneeId) {
      Id = 'consignee_id'
      idValue = consigneeId
    }
    ReadAxios({
      completeURL: `${process.env.REACT_APP_TA_API_URL}/deliveries?page=${this.state.currentPage}&limit=${this.state.itemsPerPage}&booking_branch_ids=${booking_branch_ids}&${Id}=${idValue}`,
    })
      .then((res) => {
        this.setState({
          loadingData: false,
          rowData: res.data.data,
          currentPage: res.data.meta.currentPage,
          itemCount: res.data.meta.itemCount,
          itemsPerPage: res.data.meta.itemsPerPage,
          totalItems: res.data.meta.totalItems,
          totalPages: res.data.meta.totalPages,
        });
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  onCellClicked = (rowData) => {
    // console.log("");
    // if (this.props.permissions.TA_DRIVER_MASTER.UPDATE == true) {
    //   typeof rowData.value != 'undefined' && this.onRowEdit(rowData.data);
    // }
  };

  handleSelect = (data) => {
    if (!consigneeConsignorCheck(this.props.auth.role)) {
      let selectedRows = data.api.getSelectedRows();

      let dataSet = [...this.state.selectedRows, ...selectedRows]

      let dataFilter = dataSet.filter((value, index, self) => {
        return self.findIndex(v => v.delivery_no === value.delivery_no) === index;
      })

      this.setState({ selectedRows: dataFilter });
    }
  };

  onRowEdit = (rowData) => {
    // console.log("");
    // this.props.history.push("/edit-driver", {
    //   ...rowData,
    //   title: "edit_title",
    // });
  };

  onRowDelete = (alert) => {
    if (alert.type === "success") this.props.successAlert(alert);
    else this.props.errorAlert(alert);
    this.props.history.push("/driver");
    this.props.history.go();
  };

  handlePaginationChange = (e, { activePage }) => {
    let payload = this.state.payload;
    this.setState(
      {
        loadingData: true,
        showstatusloader: true,
        currentPage: activePage,
        rowData: [],
      },
      () => {
        this.handleOrderAPICall();
      }
    );
  };

  handleMetaSearch = (data) => {
    this.setState({loadingData: true})
    let booking_branch_ids = branch_Ids?.length > 0 ? branch_Ids.toString()
      : ''
    ReadAxios({
      completeURL: `${process.env.REACT_APP_TA_API_URL}/deliveries?delivery_reference_no=${data.delivery_reference_no}&invoice_no=${data.invoice_no}&limit=${this.state.itemsPerPage}&booking_branch_ids=${booking_branch_ids}&invoice_reference_no=${data.invoice_reference_no}&lr_no=${data.lr_no}`,
    })
      .then((res) => {
        this.setState({
          loadingData: false,
          rowData: res.data.data,
          currentPage: res.data.meta.currentPage,
          itemCount: res.data.meta.itemCount,
          itemsPerPage: res.data.meta.itemsPerPage,
          totalItems: res.data.meta.totalItems,
          totalPages: res.data.meta.totalPages,
        });
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  openDeliveryModal = (data, mode) => {
    this.setState({ passMode: mode });

    ReadAxios({
      completeURL: `${process.env.REACT_APP_TA_API_URL}/deliveries/${data.delivery_id}/delivery`,
    })
      .then((res) => {
        this.setState({
          deliveryDataFetch: res.data.data,
          clickedDeliveryID: res.data.data.delivery_id,
        });
      })
      .catch((err) => {
        console.log("err", err);
      });

    this.setState({ openModalDelivery: true });
  };

  addDeliveryDetails = (deliveryData) => {
    UpdateAxios({
      patchURL: `${process.env.REACT_APP_TA_API_URL}/deliveries/${this.state.clickedDeliveryID}`,
      payload: { ...deliveryData[0] },
      uniqueId: this.state.clickedDeliveryID,
    })
      .then((response) => {
        if(response.data.status==1){
          cogoToast.success(response.data?.message , {position:"top-right"});
        setTimeout(()=>{
          window.location.reload();
        },1000)
        }else{
          cogoToast.error(response.data?.message , {position:"top-right"});
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  setOpenModalDeliveryClose = () => {
    this.setState({ openModalDelivery: false });
  };

  handleMovementType = (movementType) => {
    this.setState({ selectedMovementType: movementType });
  };

  render() {
    const { t } = this.props;
    const { rowData } = this.state;
    const Columns = [
      {
        headerName: t("table_view.delivery_no") || "Delivery Number",
        field: "delivery_no",
        sortable: true,
        tooltipField: "delivery_no",
        filter: true,
        checkboxSelection: (params) => {
          if (consigneeConsignorCheck(this.props.auth.role)) {
            return false
          }
          if (params.data.delivery_status) {
            if (
              params.data.delivery_status.delivery_code == deliveryCode_CANCEL ||
              params.data.delivery_status.delivery_code == deliveryCode_LOADING_GATEOUT ||
              params?.data?.order_allotment_status?.allotment_code == deliveryCode_ALLOC
            )
              return false;
            else return true;
          } else {
            return true;
          }
        },
        cellClass: params => {
          return (params?.data?.order_allotment_status?.allotment_code == deliveryCode_ALLOC) ? 'padding-left-40' : 'padding-left-0';
        }
      },
      {
        headerName: t("table_view.order_no") || "Reference Number",
        field: "order_no",
        sortable: true,
        tooltipField: "order_no",
        filter: true,
      },

      {
        headerName: t("table_view.common_order_no") || "Order Number",
        field: "common_order_number",
        sortable: true,
        tooltipField: "common_order_number",
        filter: true,
      },

      {
        headerName: t("table_view.lr_no") || "LR No",
        field: "lr_no",
        sortable: true,
        filter: true,
        tooltipField: "lr_no",
        // hide: true,
      },
      {
        headerName: t("table_view.gross_weight") || "Gross Weight",
        field: "gross_weight",
        sortable: true,
        filter: true,
        tooltipField: "gross_weight",
        // hide: true,
      },
      {
        headerName: t("table_view.pending_gross_weight") || "Pending Gross Weight",
        field: "pending_gross_weight",
        sortable: true,
        filter: true,
        tooltipField: "pending_gross_weight",
        // hide: true,
      },
      {
        headerName: t("table_view.consignor") || "Consignor Name",
        field: "consignor_name",
        sortable: true,
        filter: true,
        tooltipField: "consignor_name",
        // hide: true,
      },
      {
        headerName: t("table_view.consignee") || "Consignee Name",
        field: "consignee_name",
        sortable: true,
        filter: true,
        tooltipField: "consignee_name",
        // hide: true,
      },
      {
        headerName: t("table_view.from_city") || "From City",
        field: "source",
        sortable: true,
        filter: true,
        tooltipField: "source",
        // hide: true,
      },
      {
        headerName: t("table_view.to_city") || "To City",
        field: "destination",
        sortable: true,
        filter: true,
        tooltipField: "destination",
        // hide: true,
      },
      {
        headerName: t("table_view.remarks") || "Remarks",
        field: "remarks",
        sortable: true,
        tooltipField: "remarks",
        filter: true,
      },
      {
        headerName: t("table_view.lr_date") || "LR Date",
        field: "lr_date",
        sortable: true,
        filter: true,
        tooltipField: "lr_date",
        valueFormatter: function (params) {
          return params.value
            ? moment(params.value).format("DD-MM-yyyy")
            : "Na";
        },
        // hide: true,
      },
      {
        headerName: t("table_view.booking_branch") || "Booking Branch",
        field: "booking_branch_name",
        sortable: true,
        filter: true,
        tooltipField: "booking_branch_name",
        // hide: true,
      },
      {
        headerName:
          t("table_view.billing_party_branch_name") || "Billing Party Branch",
        field: "billing_party_branch_name",
        sortable: true,
        filter: true,
        tooltipField: "billing_party_branch_name",
        // hide: true,
      },
      {
        headerName: t("table_view.billing_party_name") || "Billing Party",
        field: "billing_party_name",
        sortable: true,
        filter: true,
        tooltipField: "billing_party_name",
        // hide: true,
      },
      {
        headerName: t("table_view.delivery_status") || "Delivery Status",
        field: "delivery_status.delivery_text",
        sortable: true,
        tooltipField: "delivery_status.delivery_text",
        filter: true,
      },
      {
        headerName: t("table_view.container_no") || "Container Number",
        field: "container_no",
        sortable: true,
        filter: true,
        tooltipField: "container_no",
        hide: true,
      },
      {
        headerName:
          t("table_view.expected_pickup_date") || "Expected Pickup Date",
        field: "expected_pickup_date",
        sortable: true,
        tooltipField: "expected_pickup_date",
        filter: true,
        valueFormatter: function (params) {
          return params.value
            ? moment(params.value).format("DD-MM-yyyy")
            : "Na";
        },
      },
      {
        headerName:
          t("table_view.expected_delivery_date") || "Expected Delivery Date",
        field: "expected_delivery_date",
        sortable: true,
        tooltipField: "expected_delivery_date",
        filter: true,
        valueFormatter: function (params) {
          return params.value
            ? moment(params.value).format("DD-MM-yyyy")
            : "Na";
        },
      },
      {
        //headerName: "Pdf/View",
        headerName: "Pdf",
        field: "edit",
        cellRenderer: "DeliveriesActionCollection",
        suppressToolPanel: true,
        pinned: "right",
        width: 180,
        minWidth: 180,
        maxWidth: 180
      },
    ];

    let rowValue = [];

    var frameworkcomponent = {
      DeliveriesActionCollection: DeliveriesActionCollection,
    };

    rowData &&
      rowData.forEach((object, index) => {
        let temp = {};
        temp = object;
        let delivery_text = { delivery_text: "NA" };
        temp.delivery_no = object?.delivery_no || "NA";
        temp.order_no = object?.order_no || "NA";
        temp.common_order_number = object?.order?.common_order_number ? object.order.common_order_number : "NA";
        temp.lr_no = object?.lr_no || "NA";
        temp.lr_date = object?.lr_date || "NA";
        temp.booking_branch_name = object?.booking_branch_name || "NA";
        temp.source = object?.source || "NA";
        temp.destination = object?.destination || "NA";
        temp.billing_party_branch_name =
          object?.billing_party_branch_name || "NA";
        temp.billing_party_name = object?.billing_party_name || "NA";
        temp.consignor_name = object?.consignor_name || "NA";
        temp.consignee_name = object?.consignee_name || "NA";
        temp.gross_weight = object?.gross_weight || "NA";
        temp.pending_gross_weight = object?.pending_gross_weight || "NA";
        temp.remarks = object?.remarks || "NA";
        temp.delivery_status = object?.delivery_status?.delivery_text
          ? object.delivery_status.delivery_text
          : delivery_text;
        temp.container_no = object?.container_no || "NA";

        rowValue[index] = temp;
      });

    return (
      <React.Fragment>
        <DeliveryAgGridTable
          addNewDelivery={!consigneeConsignorCheck(this.props.auth.role)}
          isLoading={this.state.loadingData}
          columnDefs={Columns}
          rowData={rowValue}
          openDeliveryModal={this.openDeliveryModal}
          //rowData={rowData}
          titleBarTitle={this.props.t("title") || "Drivers"}
          titleBarLink={"/add-driver"}
          baseURL={"driverMaster"}
          keyIndex={"driverMasterId"}
          onEdit={this.onRowEdit}
          cellDoubleClicked={this.onCellClicked}
          onSelectionChanged={this.handleSelect}
          onDelete={this.onRowDelete}
          hideRowEdit={!this.props.permissions.TA_DRIVER_MASTER.UPDATE}
          hideRowDelete={!this.props.permissions.TA_DRIVER_MASTER.DELETE}
          handlePaginationChange={this.handlePaginationChange}
          currentPage={this.state.currentPage}
          totalPages={this.state.totalPages}
          handleMetaSearch={this.handleMetaSearch}
          extraComponents={frameworkcomponent}
          selectedRows={this.state.selectedRows}
          exportHidden={false}
        />

        {this.props.auth.role == "Quality Control" ? null : (
          <>
            {this.state.selectedRows.length > 0 &&
              !consigneeConsignorCheck(this.props.auth.role) ? (
              <div className="life-cycle w3-white p-2">
                <Grid columns={2} className="ml-2">
                  <Grid.Row>
                    <Grid.Column width={2} className="mr-4">
                      <FormikModalMapDelivery
                        order={this.state.selectedRows}
                        role={this.props.auth.role}
                      // reFetchOrder={this.fetchOrderDetails}
                      />
                      {/* <Button circular size="mini"
                        type="button"
                        // onClick={handleOpen}
                        // disabled={role == "Broker" ? true : false}
                        size="mini"
                        basic color="primary"
                        className="w3-blue w3-round w3-hover-blue"
                      >
                        {this.props.t("action_button.club_deliveries") || "Club Deliveries"}
                      </Button> */}
                    </Grid.Column>
                    <Grid.Column width={2}>
                      <FormikModalDemapDelivery
                        order={this.state.selectedRows}
                        role={this.props.auth.role}
                      />
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </div>
            ) : null}
          </>
        )}

        <ModalEditAddDeliveries
          size="large"
          btime={21}
          reqon={new Date()}
          t={t}
          //movement_type={this.state.selectedMovementType}
          deliveryDataFetch={this.state.deliveryDataFetch}
          OpenModel={this.state.openModalDelivery}
          handleClose={this.setOpenModalDeliveryClose}
          onlyDelivery={true}
          handleMovementType={this.handleMovementType}
          mode={this.state.passMode}
          addDeliveryDetails={this.addDeliveryDetails}
        />
      </React.Fragment>
    );
  }
}

const mapStateToProps = ({ allorders, locales, permissions, auth }) => {
  return {
    allorders,
    auth,
    permissions,
    locales,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    read: () => dispatch(readOrderDispatcher()),
    success: (alert) => dispatch(successAlertDispatcher(alert)),
    error: (alert) => dispatch(errorAlertDispatcher(alert)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(translate("deliverylist")(DeliveryList));
